import type { Locale } from "@i18n/react";

export const isValidKidsLocale = (locale: Locale) =>
  ["en", "en-PH"].includes(locale);
